// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7758) return "static/chunks/7758-a8d9122707b944f8.js";
	if (chunkId === 3613) return "static/chunks/3613-78a38c31784b69d6.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5058":"42f4b897f4890347","6265":"9ad82ccb2f9e6efa"}[chunkId] + ".js";
};